/* eslint-disable no-param-reassign */
const AxiosGlobal = {
  install(Vue) {
    const http = axios.create({
      baseURL: 'http://174.138.110.236/api',
      timeout: 5000,
    });
    Vue.prototype.request = (
      config,
      authorization,
      responseHandler,
      errorHandler,
      asyncRequest = true,
    ) => {
      // const handleError = (error) => {
        // let log;
        // if (error.response) {
        //   console.log(error.response.data);
        //   console.log(error.response.status);
        //   console.log(error.response.headers);

        //   const dataMsg = error.response.data.message;
        //   if (_.isPlainObject(dataMsg)) {
        //     _.forOwn(dataMsg, (value) => {
        //       log += `${value} \n`;
        //     });
        //   } else {
        //     log = dataMsg;
        //   }
        // } else if (error.request) {
        //   console.log(error.request);
        //   log = error.request;
        // } else {
        //   console.log('Error', error.message);
        //   log = error.message;
        // }
        // console.log(error.config);

        // this.alertMessage = log;
        // this.alertVariant = 'danger';
        // this.showAlert();
        // this.requestError = log;
        // this.requestLoading = false;
      // };
      if (asyncRequest) {
        (async () => {
          try {
            let response;
            if (authorization) {
              const httpAuth = axios.create({
                baseURL: 'http://174.138.110.236/api',
                timeout: 5000,
                headers: {
                  Authorization: `Bearer ${JSON.parse(localStorage.getItem('token'))}`,
                },
              });
              response = await httpAuth(config);
            } else {
              response = await http(config);
            }
            responseHandler(response);
          } catch (e) {
            // handleError(e);
            errorHandler(e);
          }
        })();
      } else if (authorization) {
        const httpAuth = axios.create({
          baseURL: 'http://174.138.110.236/api',
          timeout: 5000,
          headers: {
            Authorization: `Bearer ${JSON.parse(localStorage.getItem('token'))}`,
          },
        });
        httpAuth(config)
          .then((response) => {
            responseHandler(response);
          })
          .catch((e) => {
            // handleError(e);
            errorHandler(e);
          });
      } else {
        http(config)
          .then((response) => {
            responseHandler(response);
          })
          .catch((e) => {
            // handleError(e);
            errorHandler(e);
          });
      }
    };
  },
};

export default AxiosGlobal;



// WEBPACK FOOTER //
// ./src/plugins/AxiosGlobal.js